import { createContext, useContext } from 'react';

interface RiskInstance {
  publishRiskData: () => Promise<string>;
}

interface RiskJsContext {
  riskInstance: RiskInstance | undefined;
}

export const RiskJsContext = createContext<RiskJsContext | null>(null);

export const useRiskJsContext = () => useContext(RiskJsContext)!;
